/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachment,
    DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachmentFromJSON,
    DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachmentFromJSONTyped,
    DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachmentToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequest
 */
export interface DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequest {
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequest
     */
    actual_stitch_count?: number;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequest
     */
    final_stitch_count?: number;
    /**
     * 
     * @type {Array<DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachment>}
     * @memberof DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequest
     */
    attachments?: Array<DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachment> | null;
}

export function DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequestFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequest {
    return DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequestFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'actual_stitch_count': !exists(json, 'actual_stitch_count') ? undefined : json['actual_stitch_count'],
        'final_stitch_count': !exists(json, 'final_stitch_count') ? undefined : json['final_stitch_count'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachmentFromJSON)),
    };
}

export function DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequestToJSON(value?: DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'actual_stitch_count': value.actual_stitch_count,
        'final_stitch_count': value.final_stitch_count,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachmentToJSON)),
    };
}


